import React, { useMemo, useState } from "react";
import "../styles/FAQContenidoAds.scss";

const FAQContenidoAds = () => {
  const faqs = useMemo(
    () => [
      {
        q: "¿La inversión en pauta está incluida?",
        a: "Depende del plan. En Plan Impulso incluye una pauta sugerida de $500 MXN. En los demás planes, la pauta es adicional y la define el cliente. Nosotros te recomendamos un presupuesto según tu objetivo y zona.",
      },
      {
        q: "¿En cuánto tiempo se ven resultados?",
        a: "Normalmente desde la primera semana puedes empezar a recibir mensajes si ya tienes una oferta clara y una campaña activa. Los mejores resultados llegan cuando optimizamos y repetimos lo que funciona durante el mes.",
      },
      {
        q: "¿Qué necesito para empezar?",
        a: "Solo 3 cosas: 1) qué vendes, 2) tu zona (ciudad/colonias) y 3) tu objetivo (mensajes/prospectos/ventas). Si no tienes página, con el Plan Activación (Desde Cero) te la configuramos.",
      },
      {
        q: "¿Ustedes crean el contenido y los diseños?",
        a: "Sí. Creamos los diseños, copys y estructura de contenido según el plan. Todo enfocado a conversión (mensajes, prospectos o ventas), no solo a verse bonito.",
      },
      {
        q: "¿Puedo contratar solo campañas sin contenido?",
        a: "Sí. Si ya tienes redes y solo quieres campañas, puedes elegir Plan Impulso o Plan Flexible (por ciclos de 7 días).",
      },
      {
        q: "¿Qué pasa si ya tengo agencia o alguien que publica?",
        a: "Podemos trabajar solo campañas, o coordinar la estrategia para que el contenido y los anuncios estén alineados. Cuando el mensaje es consistente, la conversión mejora.",
      },
      {
        q: "¿El Plan Bot qué incluye exactamente?",
        a: "Incluye campañas activas todo el mes y la implementación de un bot básico en Messenger para responder, filtrar y capturar datos (nombre, teléfono y servicio de interés). Te llegan prospectos más ordenados.",
      },
      {
        q: "¿Hay contrato forzoso?",
        a: "No manejamos contratos forzosos. Recomendamos mínimo 1 mes para medir y optimizar. Si continúas, el rendimiento suele mejorar con cada ciclo.",
      },
    ],
    []
  );

  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (idx) => {
    setOpenIndex((prev) => (prev === idx ? -1 : idx));
  };

  return (
    <section className="ovit-faq" id="faq">
      <div className="ovit-faq__bg" aria-hidden="true">
        <div className="ovit-faq__grid" />
        <div className="ovit-faq__glow ovit-faq__glow--1" />
        <div className="ovit-faq__glow ovit-faq__glow--2" />
      </div>

      <div className="ovit-faq__container">
        <header className="ovit-faq__header">
          <h2 className="ovit-faq__title">
            Preguntas <span>Frecuentes</span>
          </h2>
          <p className="ovit-faq__subtitle">
            Resolvemos las dudas más comunes antes de iniciar. (Así decides rápido y sin vueltas).
          </p>
        </header>

        <div className="ovit-faq__wrap">
          <div className="ovit-faq__list" role="list">
            {faqs.map((f, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div
                  className={`ovit-faqItem ${isOpen ? "is-open" : ""}`}
                  key={f.q}
                >
                  <button
                    type="button"
                    className="ovit-faqItem__q"
                    onClick={() => toggle(idx)}
                    aria-expanded={isOpen}
                  >
                    <span>{f.q}</span>
                    <span className="ovit-faqItem__icon" aria-hidden="true">
                      {isOpen ? "−" : "+"}
                    </span>
                  </button>

                  <div className="ovit-faqItem__a" aria-hidden={!isOpen}>
                    <div className="ovit-faqItem__aInner">{f.a}</div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Side CTA */}
          <aside className="ovit-faq__side">
            <div className="ovit-faqSideCard">
              <div className="ovit-faqSideCard__badge">Recomendación</div>
              <div className="ovit-faqSideCard__title">
                Si quieres el plan que más se vende:
              </div>
              <div className="ovit-faqSideCard__desc">
                El <strong>Plan Crecimiento</strong> suele ser el punto ideal entre
                presencia + campañas + flujo constante de mensajes.
              </div>

              <div className="ovit-faqSideCard__actions">
                <a className="ovit-faqSideCard__btn" href="#planes">
                  Ver planes
                </a>
                <a className="ovit-faqSideCard__btn ovit-faqSideCard__btn--ghost" href="https://wa.me/525588093678?text=Hola,%20me%20interesa%20recibir%20informaci%C3%B3n%20sobre%20sus%20servicios%20de%20marketing%20digital.%20Quiero%20hacer%20crecer%20mi%20negocio%20y%20generar%20m%C3%A1s%20clientes." target="_blank" rel="noopener noreferrer">
                  Hablar por WhatsApp
                </a>
              </div>

              <div className="ovit-faqSideCard__note">
                *Te decimos qué plan te conviene según tu giro y tu zona.
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default FAQContenidoAds;